import {
  checkCustomerExists,
  checkExistOtp,
  customerSignUp,
  validateOtp,
} from '@porterin/booking-flow/src/auth/domain/repo/customerAuth';
import { customerLogout } from '@porterin/booking-flow/src/auth/domain/repo/customerLogout';
import { customerProfile } from '@porterin/booking-flow/src/auth/domain/repo/customerProfile';
import { resendOtp } from '@porterin/booking-flow/src/auth/domain/repo/resendOtp';

export const authRepo = {
  checkExistOtp: checkExistOtp,
  checkCustomerExists: checkCustomerExists,
  customerSignUp: customerSignUp,
  validateOtp: validateOtp,
  resendOtp: resendOtp,
  customerLogout: customerLogout,
  customerProfile: customerProfile,
};

export type AuthRepository = typeof authRepo;
